import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/**
 * Hyperliquid Staking Reward History 単一レコードスキーマ
 * README の "API Response Data" セクションを元に作成。
 * 数値文字列フィールド (totalAmount) は decimalSchema を使用して BigDecimal 化。
 */
const stakingRewardHistorySchema = z.object({
  /** タイムスタンプ（ミリ秒） */
  time: z.number().int(),
  /** 報酬の種類（例: delegation, commission） */
  source: z.string(),
  /** 合計金額 (数値文字列) */
  totalAmount: decimalSchema,
})

/**
 * API 応答全体スキーマ
 * ルートは報酬データの配列。
 */
export const responseSchema = z.array(stakingRewardHistorySchema)
